import type { ServerUnlayerDesign } from './unlayer.schema'

function convertServerUnlayerDesign(unlayerDesign: ServerUnlayerDesign) {
  return {
    ...unlayerDesign,
    body: {
      ...unlayerDesign.body,
      headers: unlayerDesign.body.headers ?? [],
      footers: unlayerDesign.body.footers ?? [],
    },
  }
}

export { convertServerUnlayerDesign }
